import { getAxiosClient } from "../../axios-client";
import { PutSubcontractorUpdateRequestBody, PutSubcontractorUpdateResponse } from "./types";

const axiosClient = getAxiosClient();
export const putSubcontractorUpdate = async (body: PutSubcontractorUpdateRequestBody) => {
    return await axiosClient.ax.put<PutSubcontractorUpdateResponse>("/Subcontractor/SubcontractorUpdate", body);
};
